import { all, takeLatest } from "redux-saga/effects";
import processAction from "../../../../utils/processAction";
import { actionTypes as saleActionTypes } from "./reducer";
import {
  getSale as getSaleService,
  updateSale as updateSaleService,
  deleteSale as deleteSaleService,
  addSale as addSaleService
} from "./service";

function* getSales({ company_id, params }) {
  yield processAction({
    params: { company_id, params },
    service: getSaleService,
    success: saleActionTypes.GET_SALE_SUCCESS,
    failed: saleActionTypes.GET_SALE_FAILED
  })
}

function* addSale({ company_id, body }) {
  yield processAction({
    params: { company_id, body },
    service: addSaleService,
    success: saleActionTypes.ADD_SALE_SUCCESS,
    failed: saleActionTypes.ADD_SALE_FAILED
  })
}

function* updateSale({ company_id, sale_id, body }) {
  yield processAction({
    params: { company_id, sale_id, body },
    service: updateSaleService,
    success: saleActionTypes.UPDATE_SALE_SUCCESS,
    failed: saleActionTypes.UPDATE_SALE_FAILED
  })
}

function* deleteSale({ company_id, sale_id }) {
  yield processAction({
    params: { company_id, sale_id },
    service: deleteSaleService,
    success: saleActionTypes.DELETE_SALE_SUCCESS,
    failed: saleActionTypes.DELETE_SALE_FAILED
  })
}

function* watchSale() {
  yield all([
    takeLatest(saleActionTypes.GET_SALE, getSales),
    takeLatest(saleActionTypes.UPDATE_SALE, updateSale),
    takeLatest(saleActionTypes.DELETE_SALE, deleteSale),
    takeLatest(saleActionTypes.ADD_SALE, addSale)
  ])
}

export default [watchSale()]




// WEBPACK FOOTER //
// ./src/modules/company/pages/sales-forecast/saga.js